import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ffcdde6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "borrow-applyDetail" }
const _hoisted_2 = {
  class: "sign-table-wrapper",
  style: {"margin-left":"-10px"}
}

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { accountTaxApplyInfo } from "@/api/process_bank";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }




const COLUMNS = [
  {
    title: "文件名称",
    slots: { customRender: "FileName" },
    width: 880,
  },
  {
    title: "操作",
    width: 150,
    slots: { customRender: "actionBtn" },
  },
];
watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

const getdata = async () => {
  const { Data } = await accountTaxApplyInfo({
    BranchCompanyFlowId: props.folwId,
  });
  tableData.value = [...(Data?.PageFiles || []), ...(Data?.PostFiles || [])];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "开户报税资料申请",
      style: {"margin-top":"24px","margin-bottom":"20px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(RisTable, {
          columns: COLUMNS,
          "table-data": tableData.value
        }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})